module.exports = __webpack_public_path__ + "static/media/PaymentsAnswer.6caf9df9.svg";